import React, { useContext, useEffect } from 'react';
import Styled from './CirtuitoPrivateStyled';
import OverviewExclusivo from '../components/OverviewExclusivo';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import circuitoLogo from './../../../../images/solutions/logo/circuitoLogo.png';
import CicloExclusivo from '../components/CicloExclusivo';
import { ListMateriaisCircuitoPrivatePlanoAnual } from './ListMateriasCircuitoPrivate';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const CircuitoPrivate = () => {
    const { idsMyCategorias, loading } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);
    const isApoioCultura = idsMyCategorias.some(id => id === 35) && !usuarioLogado.email.includes('@ias');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Styled.Container isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                    ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                    : ''
                        }
                        img={'ExclusivoCircuitoImagem1.JPG'}
                        logo={circuitoLogo}
                        title="Circuito 360 – Educação Integral nos Anos Iniciais"
                        description={`
                       O <b>Circuito 360</b> tem como propósito apoiar as secretarias de educação na elaboração e gestão de suas políticas educacionais para os <b>anos iniciais do Ensino Fundamental</b>, 
                       a partir da perspectiva da <b>educação integral</b>. <br/><br/>
                       A proposta contribui diretamente para: <br/><br/>
                          <ol style="list-style: inside disc;">
                            <li><b>Implantar políticas de educação integral</b> nos anos iniciais do Ensino Fundamental.</li>
                            <li><b>Desenvolver a competência gestora</b> dos profissionais responsáveis pelos anos iniciais, tanto nos aspectos pedagógicos quanto na rotina escolar e na política educacional.</li>
                            <li><b>Fortalecer o papel do coordenador pedagógico</b> como formador da equipe docente da escola.   </li>
                            <li><b>Constituir uma equipe de professores alfabetizadores</b>, comprometida com a aprendizagem de todos os estudantes.  </li>
                            <li><b>Incorporar a metodologia de resolução de problemas</b> à prática pedagógica, valorizando o cotidiano e o repertório sociocultural dos alunos. </li>
                          </ol>
                        Acesse o documento de visão geral e conheça melhor os caminhos para implementar o Circuito 360 em sua rede. 
                `}
                        regua={
                            [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                    ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                    : ''
                        }
                        arquivo={'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Circuito 360 - Visao Geral.pdf'}
                        nome_arquivo="Circuito_360_Visao_Geral"
                    />
                    <CicloExclusivo
                        title="Trilha Formativa Circuito 360"
                        description={`
                        A <b>trilha formativa do Circuito 360</b> foi pensada para apoiar técnicos das secretarias de educação, gestores regionais, coordenadores pedagógicos e professores na implementação da proposta. 
                        <br/><br/>
                        Ao longo do percurso, você vai conhecer os conteúdos essenciais da solução educacional e se apropriar das práticas e estratégias que fortalecem a educação integral nos anos 
                        iniciais do Ensino Fundamental. 
                        <br/><br/>
                        Os <b>ciclos 1 e 3 acontecem de forma presencial</b>, promovendo momentos de troca, escuta e construção coletiva. Já os <b>ciclos 2 e 4 são realizados na plataforma</b>, permitindo 
                        flexibilidade e aprofundamento dos conteúdos no seu tempo. 
                        <br/><br/>
                    
                       <b>Vamos juntos nessa jornada?</b> <br/>
                        Inicie agora a sua trilha formativa! 
                        `}
                        img="ExclusivoCircuitoImagem2.jpg"
                        itens={
                            [9, 11, 12, 13, 18, 19, 22, 25].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? [
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 1',
                                        url: '/cursos/circuito360/circuito360-ciclo1?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 2',
                                        url: '/cursos/circuito360/circuito360-ciclo2?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 3',
                                        url: '/cursos/circuito360/circuito360-ciclo3?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 4',
                                        url: '/cursos/circuito360/circuito360-ciclo4?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Aprenda a usar a Farol',
                                        url: '/cursos/farol/farol-circuito?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                ]
                                : isApoioCultura ? [
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 2',
                                        url: '/cursos/circuito360/circuito360-ciclo2?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 4',
                                        url: '/cursos/circuito360/circuito360-ciclo4?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },

                                ] : [
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 1',
                                        url: '/cursos/circuito360/circuito360-ciclo1?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 2',
                                        url: '/cursos/circuito360/circuito360-ciclo2?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 3',
                                        url: '/cursos/circuito360/circuito360-ciclo3?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                    {
                                        title: 'Curso Circuito 360 - Ciclo 4',
                                        url: '/cursos/circuito360/circuito360-ciclo4?redirect=exclusivo/circuito-360',
                                        isBlock: false,
                                        titleIsBlock: `Esse curso não está disponível.`,
                                    },
                                ]
                        }
                    />

                    <MateriaisExclusivos
                        title="ACESSE OS MATERIAIS DO CIRCUITO 360"
                        description={`Acesse os materiais exclusivos do <b>Circuito 360</b> e conheça mais de perto a proposta. Eles foram pensados para apoiar sua prática e facilitar a implementação da solução na rede. `}
                        img={'anexo_storage_files_8557788060963491135.jpeg_2024-11-26-1732644557765.jpeg'}
                        items={ListMateriaisCircuitoPrivatePlanoAnual}
                    />
                    <SessionFerramentaVideo solucaoId={1} />
                    <ContactContainer />
                </>
            )}
        </Styled.Container>
    );
};

export default CircuitoPrivate;
